module.exports = __webpack_public_path__ + "static/media/order-log-empty.a60e3b43.svg";